import { IScheduledEmail } from '@/types/email.types';
import { Get } from '../helpers';

export async function GetProjectScheduledEmails({ projectUuid }: { projectUuid: string }): Promise<IScheduledEmail[]> {
  return Get({
    path: `/v3/admin/scheduled-emails/event-emails/${projectUuid}`,
  });
}
